import { Box, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'

const ProductIntro3 = () => {
  return (
    <Box h="100%" py="50px">
      <Flex
        direction={{ base: 'column', md: 'row' }} // Column for small screens, row for larger screens
        gap={{ base: '50px', md: '150px' }}
        alignItems="center"
      >
        <Box w={{ base: '100%', md: '50%' }} h="100%">
          <AspectRatio position="relative" ratio={776 / 1606}>
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/AM-1740446725334.png"
              alt="product intro"
              fill
            />
          </AspectRatio>
        </Box>
        <Flex
          w={{ base: '100%', md: '50%' }}
          h="100%"
          className="flex-col items-end gap-8"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-promotion-1742443973645.png"
            alt="product intro"
            width={500}
            height={700}
            className="w-full h-full object-cover"
          />

          <Link
            target="_blank"
            rel="noopener noreferrer"
            href="https://habbit.sg/products/zero2one-hair-tonic-by-ellixi-plus"
          >
            <Box
              w={{ base: '160px', md: '200px' }}
              h="100%"
              mr={{ base: '16px', md: '50px' }}
            >
              <AspectRatio ratio={105 / 31} w="100%" position="relative">
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/PM-1737465307082.png"
                  alt="product intro"
                  fill
                />
              </AspectRatio>
            </Box>
          </Link>
        </Flex>
      </Flex>
    </Box>
  )
}

export default ProductIntro3
